'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import l from "../../external/react-modal/lib/index.js";
import { FontAwesomeIcon as c } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import n from "../../external/classnames/index.js";
import { faXmark as i } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import o from "./modal.module.scss.js";
l.setAppElement("body");
const y = ({ children: r, onModalClose: s, className: m, ...t }) => {
  const a = () => {
    s && s(!1);
  };
  return /* @__PURE__ */ e.jsxs(
    l,
    {
      onAfterClose: () => s(!1),
      contentLabel: `Modal: ${t.id}`,
      className: o.window,
      overlayClassName: o.overlay,
      shouldCloseOnOverlayClick: !0,
      onRequestClose: a,
      ...t,
      children: [
        /* @__PURE__ */ e.jsx(
          "button",
          {
            "aria-label": "close",
            onClick: a,
            className: o.close,
            children: /* @__PURE__ */ e.jsx(c, { className: "text-grey-400", icon: i })
          }
        ),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: n(o.content, m),
            "data-modal-content": !0,
            children: r
          }
        )
      ]
    }
  );
};
export {
  y as default
};
